(function () {
  if (window.__GRID_CARD_VARIANTS__) return;
  window.__GRID_CARD_VARIANTS__ = true;

  function getCard(el) {
    return el.closest('product-card') || el.closest('.card--product');
  }

  // JSON "formatted" do variant-picker (tem price com <sup>)
  function getFormattedMap(card) {
    if (card.__formattedMap) return card.__formattedMap;
    const jsonEl = card.querySelector('variant-picker script[type="application/json"]');
    if (!jsonEl) return null;
    try {
      const parsed = JSON.parse(jsonEl.textContent);
      card.__formattedMap = parsed.formatted || null;
      return card.__formattedMap;
    } catch (e) {
      return null;
    }
  }

  // JSON do Loop plans
  function getPlanData(card) {
    if (card.__planData) return card.__planData;
    const el = card.querySelector('script[id^="loopPlans-"]');
    if (!el) return null;
    try {
      card.__planData = JSON.parse(el.textContent);
      return card.__planData;
    } catch (e) {
      return null;
    }
  }

  function getSelectedVariantId(card) {
    const checked = card.querySelector('.option-selector__btns .opt-btn:checked');
    if (!checked) return null;
    const label = card.querySelector('label[for="' + checked.id + '"]');
    const hidden = label?.querySelector('.variant_id_by_checked');
    return hidden ? hidden.value : null;
  }

  function syncFormVariantId(card, variantId) {
    const form = card.querySelector('form.js-product-form');
    const idInput = form?.querySelector('input[name="id"]');
    if (idInput && variantId) idInput.value = variantId;
  }

  function updateCardPrice(card, variantId) {
    const formatted = getFormattedMap(card);
    if (!formatted || !formatted[variantId] || !formatted[variantId].price) return;

    const priceCurrent = card.querySelector('.product-card__price .price__current');
    const fromEl = card.querySelector('.product-card__price .price__from');
    if (!priceCurrent) return;

    // mantém <sup> exatamente como o tema gera
    priceCurrent.innerHTML = formatted[variantId].price;

    // se você quiser parar de mostrar "From" quando escolhe variante:
    if (fromEl) fromEl.style.display = 'none';
  }

  function fmtMoney(cents) {
    var fmt = (document.body && document.body.dataset && document.body.dataset.moneyFormat) || '${{amount}}';
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, fmt);
      }
    } catch (e) {}
    // Fallback (Shopify.formatMoney ainda não carregou): aplica o money_format
    // do tema manualmente pra NÃO perder o símbolo da moeda ($).
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/<[^>]+>/g, '');
  }

  function updateSubscription(card, variantId) {
    const wrap = card.querySelector('.js-loop-mini');
    if (!wrap) return;

    const planData = getPlanData(card);
    const v = planData?.variants?.[variantId];
    if (!v) return;

    const otPriceEl  = wrap.querySelector('.ot-price');
    const subPriceEl = wrap.querySelector('.sub-price');
    const saveEl     = wrap.querySelector('.js-save');
    const subBlock   = wrap.querySelector('.purchase_option.sub');
    const subRadio   = wrap.querySelector('input[value="sub"]');
    const sel        = wrap.querySelector('select.selling_plan_product');

    if (otPriceEl) otPriceEl.textContent = fmtMoney(v.price);

    // sem planos
    if (!v.plans || !v.plans.length) {
      if (subBlock) subBlock.style.display = 'none';
      if (sel) { sel.disabled = true; sel.name = ''; sel.innerHTML = ''; }
      if (subRadio) subRadio.disabled = true;
      return;
    }

    // com planos
    if (subBlock) subBlock.style.display = '';
    if (subRadio) subRadio.disabled = false;

    if (sel) {
      sel.innerHTML = '';
      v.plans.forEach(function (p) {
        const opt = document.createElement('option');
        opt.value = p.id;
        opt.textContent = p.name;
        sel.appendChild(opt);
      });
    }

    const subPrice = (v.plans[0].price != null ? v.plans[0].price : v.price);
    if (subPriceEl) subPriceEl.textContent = fmtMoney(subPrice);

    if (saveEl) {
      const save = (v.price > 0) ? Math.round((v.price - subPrice) * 100 / v.price) : 0;
      saveEl.textContent = save;
    }

    // name="selling_plan" só quando SUB selecionado
    const ot = wrap.querySelector('input[value="ot"]');
    function syncSellingPlanName() {
      if (!sel) return;
      if (subRadio && subRadio.checked) { sel.name = 'selling_plan'; sel.disabled = false; }
      else { sel.name = ''; sel.disabled = true; }
    }
    wrap.addEventListener('change', function (e) {
      if (e.target === ot || e.target === subRadio) syncSellingPlanName();
    });
    syncSellingPlanName();
  }

  // Estado visual do toggle One-time/Subscribe via classe (não via :checked no CSS).
  // Motivo: o Chromium não reinvalida :has(:checked)/:checked+irmão de forma
  // confiável quando o :checked migra entre radios do mesmo grupo. Classe = sólido.
  function updatePurchaseSelected(card) {
    const wrap = card.querySelector('.js-loop-mini');
    if (!wrap) return;
    wrap.querySelectorAll('.purchase_option').forEach(function (po) {
      const input = po.querySelector('input[type="radio"]');
      po.classList.toggle('is-selected', !!(input && input.checked));
    });
  }

  function apply(card) {
    updatePurchaseSelected(card);
    const vid = getSelectedVariantId(card) || card.querySelector('form.js-product-form input[name="id"]')?.value;
    if (!vid) return;
    syncFormVariantId(card, vid);
    updateCardPrice(card, vid);
    updateSubscription(card, vid);
  }

  // evento global: qualquer mudança nos chips
  document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('js-option')) return;
    const card = getCard(e.target);
    if (!card) return;

    const vid = getSelectedVariantId(card);
    if (!vid) return;

    syncFormVariantId(card, vid);
    updateCardPrice(card, vid);
    updateSubscription(card, vid);
  }, true);

  // evento global: alternância do purchase option (One-time/Subscribe)
  document.addEventListener('change', function (e) {
    const t = e.target;
    if (!t || t.type !== 'radio' || !t.name || t.name.indexOf('purchase_options_') !== 0) return;
    const card = getCard(t);
    if (card) updatePurchaseSelected(card);
  }, true);

  // init cards existentes
  document.querySelectorAll('product-card.card--product, .card.card--product').forEach(apply);

  // init cards inseridos depois (slider/infinite load).
  // Observe apenas containers que sabemos que hospedam cards, não document inteiro.
  const cardHosts = document.querySelectorAll(
    '.main-products-grid, .main-products-grid__results, .cc-featured-collection, ' +
    '.cc-product-recommendations, .cc-recently-viewed, product-recommendations, ' +
    'facet-filters-form, custom-pagination'
  );
  if (cardHosts.length) {
    const mo = new MutationObserver(function (mutations) {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches?.('product-card.card--product, .card.card--product')) apply(node);
          node.querySelectorAll?.('product-card.card--product, .card.card--product').forEach(apply);
        }
      }
    });
    cardHosts.forEach(function (host) {
      mo.observe(host, { childList: true, subtree: true });
    });
  }
})();

(function () {
  if (window.__ATC_HARDENED__) return;
  window.__ATC_HARDENED__ = true;

  // Liste as seções que queremos pedir ao servidor (ajuste/adicione se precisar)
  const SECTION_IDS = ['cart-drawer','mini-cart','cart-icon-bubble','cart-notification'];

  // --- util: abre o minicart do tema ---
  function openMiniCart() {
    // gatilhos comuns
    const triggers = document.querySelectorAll(
      '[data-cart-trigger],[data-open-cart],.js-open-cart,[aria-controls="CartDrawer"],[data-action="open-mini-cart"]'
    );
    if (triggers.length) { triggers[0].click(); return; }

    // web components / drawers frequentes
    const drawer = document.querySelector(
      'cart-drawer, minicart-drawer, cart-notification, .mini-cart, #MiniCartDrawer, [data-mini-cart]'
    );
    if (!drawer) return;
    if (typeof drawer.open === 'function') drawer.open();
    drawer.classList.add('is-open','active','open');
    drawer.removeAttribute('hidden');
    drawer.setAttribute('aria-hidden','false');
  }

  // --- util: injeta HTML do drawer onde quer que o tema espere ---
  function hydrateCartUI(sectionId, html) {
    if (!html) return false;

    // cria um DOM temporário com o HTML que veio da Section Rendering API
    const tmp = document.createElement('div');
    tmp.innerHTML = html;

    // 1) Caminho padrão: substituir a seção inteira (#shopify-section-<id>)
    const freshSection = tmp.querySelector('#shopify-section-' + sectionId);
    const liveSection  = document.getElementById('shopify-section-' + sectionId);
    if (freshSection && liveSection) {
      liveSection.replaceWith(freshSection);
      return true;
    }

    // 2) Contêineres internos conhecidos de diversos temas
    const pairs = [
      // Dawn e derivados
      ['#CartDrawer-Form',            '#CartDrawer-Form'],
      ['#CartDrawer',                 '#CartDrawer'],
      ['cart-drawer',                 'cart-drawer'],
      // Clean Canvas / Enterprise etc.
      ['.minicart-drawer__content',   '.minicart-drawer__content'],
      ['.mini-cart__content',         '.mini-cart__content'],
      ['#MiniCart-Items',             '#MiniCart-Items'],
      ['[data-cart-items]',           '[data-cart-items]'],
      // Cart notification
      ['cart-notification',           'cart-notification']
    ];

    for (const [selectorLive, selectorFresh] of pairs) {
      const live = document.querySelector(selectorLive);
      const fresh = tmp.querySelector(selectorFresh);
      if (live && fresh) {
        live.innerHTML = fresh.innerHTML;
        return true;
      }
    }

    // 3) Fallback: algumas lojas usam data-section-id
    const liveByData  = document.querySelector('[data-section-id="'+sectionId+'"]');
    const freshByData = tmp.querySelector('[data-section-id="'+sectionId+'"]');
    if (liveByData && freshByData) {
      liveByData.innerHTML = freshByData.innerHTML;
      return true;
    }

    return false;
  }

  // --- util: sincroniza o input hidden "id" com o Size selecionado ---
 function syncVariantId(form) {
  const card = form.closest('product-card') || form;

  // chip selecionado (fora do form, mas dentro do card)
  const checked = card.querySelector('.option-selector__btns .opt-btn:checked');

  // label é IRMÃ do input (não é parent), então precisa achar via for=""
  const label = checked ? card.querySelector('label[for="' + checked.id + '"]') : null;
  const hiddenId = label?.querySelector('.variant_id_by_checked')?.value;

  const idInput = form.querySelector('input[name="id"]');
  if (hiddenId && idInput) idInput.value = hiddenId;
}


  // --- intercepta todos os forms de produto do grid ---
  document.addEventListener('submit', async function (e) {
    const form = e.target;
    if (!form.matches('.js-product-form')) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    // 1) garante o variant id correto
    syncVariantId(form);

    // 2) monta payload de add-to-cart
    const fd = new FormData(form);
    fd.delete('return_to'); // evita redirects
    fd.append('sections', SECTION_IDS.join(','));
    fd.append('sections_url', window.location.pathname);

    let data;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: fd
      });

      if (!res.ok) {
        let errMsg = 'Could not add to cart';
        try {
          const err = await res.json();
          if (err && err.description) errMsg = err.description;
        } catch(_) {}
        throw new Error(errMsg);
      }

      // /cart/add.js pode devolver {id:..., sections:{...}} quando pedimos "sections"
      try { data = await res.json(); } catch(_) { data = {}; }

      // 3) se não veio "sections", busca via Section Rendering API
      if (!data || !data.sections) {
        const q = new URLSearchParams({ sections: SECTION_IDS.join(',') });
        const secRes = await fetch('/?' + q.toString(), { headers: { 'Accept': 'application/json' } });
        data = { sections: secRes.ok ? await secRes.json() : {} };
      }

      // 4) injeta cada seção que tivermos conseguido renderizar
      if (data.sections) {
        Object.entries(data.sections).forEach(([id, html]) => {
          try { hydrateCartUI(id, html); } catch(err) { console.warn('hydrate fail for', id, err); }
        });
      }

      // 5) dispara eventos que muitos temas escutam
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.body.classList.add('cart-has-items');

      // 6) abre o drawer já hidratado
      openMiniCart();

    } catch (err) {
      console.error('Add to cart error:', err);
      const box = form.querySelector('.js-form-error');
      if (box) { box.textContent = err.message || 'Error adding to cart'; box.hidden = false; }
    }
  }, true);
})();
